import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'shortenId',
})
export class ShortenIdPipe implements PipeTransform {
    transform(
        value: string,
        startLength: number = 8,
        endLength: number = 8
    ): string {
        if (!value) return '';
        if (value.length <= startLength + endLength + 3) return value;
        return `${value.substring(0, startLength)}...${value.substring(
            value.length - endLength
        )}`;
    }
}
